import React, { useState, useEffect } from 'react'

import { Container, Typography, AppBar, Snackbar, Toolbar, Button } from '@material-ui/core'

import { makeStyles } from '@material-ui/core/styles'

import LoadingOverlay from '../../../components/Misc/LoadingOverlay'
import AddressFormCard from '../../../components/Cards/AddressFormCard'
import ContactFormCard from '../../../components/Cards/ContactFormCard'

import { useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'

import { createHousehold } from '../../../actions/households/households.actions'

import MuiAlert from '@material-ui/lab/Alert'

import { cloneDeep } from 'lodash'

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
		paddingTop: '24px',
		paddingLeft: '20px',
		paddingRight: '20px',
		paddingBottom: '60px'
	},
	appBar: {
		top: 'auto',
		bottom: 0
	}
}))

const Alert = (props) => {
	return <MuiAlert elevation={6} variant="filled" {...props} />
}

const CreateClient = () => {
	const classes = useStyles()
	const history = useHistory()
	const dispatch = useDispatch()
	const facility = useSelector((state) => state.specific.facilities.selected)
	const currentClient = useSelector((state) => state.specific.households.selected)
	const loading = useSelector((state) => state.specific.households.loading)

	const initial = {
		firstName: '',
		lastName: '',
		phone: '',
		email: '',
		contact: {
			address: {
				address_1: '',
				address_2: '',
				city: '',
				state: '',
				zip_code: ''
			}
		},
		market: ''
	}

	const [client, setClient] = useState(initial)

	useEffect(() => {
		if (currentClient) {
			dispatch({ type: 'CLEAR_HOUSEHOLD' })
		}
	}, [])

	const isClientValid = () => {
		let { firstName, lastName, phone, email, market, contact } = client

		let { address } = contact
		let { address_1, city, state, zip_code } = address

		return (
			!firstName ||
			!lastName ||
			!phone ||
			!email ||
			// !contact ||
			// !address ||
			// !address_1 ||
			// !city ||
			// !state ||
			// !zip_code ||
			!market
		)
	}

	const createClient = () => {
		let clientToCreate = cloneDeep(client)

		if (clientToCreate.market) {
			clientToCreate.market = client.market._id
		}

		dispatch(createHousehold(clientToCreate, history, facility._id)).then(() => {
			setClient(initial)
		})
	}

	const goToClientsPage = () => {
		setClient(initial)

		history.push(`/clients`)
	}

	return (
		<div>
			<Container className={classes.root} maxWidth="md">
				<div>
					<Typography variant="h5" style={{ fontWeight: 800 }}>
						New Client
					</Typography>
					<ContactFormCard client={client} setClient={setClient} />
					<AddressFormCard client={client} setClient={setClient} />
				</div>
				<AppBar position="fixed" color="primary" className={classes.appBar}>
					<Toolbar>
						<Container maxWidth="md">
							<Button
								variant="contained"
								color="secondary"
								disabled={isClientValid()}
								style={{ marginRight: '8px' }}
								onClick={() => createClient()}>
								Create Client
							</Button>
							<Button variant="outlined" color="secondary" onClick={goToClientsPage}>
								Cancel
							</Button>
						</Container>
					</Toolbar>
				</AppBar>
			</Container>
			{loading ? <LoadingOverlay /> : null}
		</div>
	)
}

export default CreateClient
